import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import DOMPurify from 'dompurify';

import htmx from 'htmx.org';

import '@/events';

import { initMalvertisingDetector } from '@/malvertising_detector';
import { initExperimentView } from './ab_test';
import { initPageComponent, initSharedComponents, initAnalytics } from './load_components';

async function init() {
    window.Alpine = Alpine;
    window.htmx = htmx;
    window.DOMPurify = DOMPurify; // TODO: remove once DOMPurify is used only in modules

    // Start as early as possible: the observed malvertising auto-redirects on load.
    initMalvertisingDetector();

    initExperimentView();

    await initSharedComponents();
    await initPageComponent();
    await initAnalytics();

    Alpine.plugin(intersect);
    Alpine.plugin(collapse);
    Alpine.start();
}

init();
